__turbopack_context__.v({
  "appShell": "Z80OOW_appShell",
  "authBrandLogo": "Z80OOW_authBrandLogo",
  "authDialog": "Z80OOW_authDialog",
  "authFinePrint": "Z80OOW_authFinePrint",
  "authForm": "Z80OOW_authForm",
  "authFormSide": "Z80OOW_authFormSide",
  "authHeading": "Z80OOW_authHeading",
  "authMaterialStrip": "Z80OOW_authMaterialStrip",
  "authTab": "Z80OOW_authTab",
  "authTabActive": "Z80OOW_authTabActive",
  "authTabs": "Z80OOW_authTabs",
  "authVisual": "Z80OOW_authVisual",
  "authVisualCopy": "Z80OOW_authVisualCopy",
  "authVisualGrid": "Z80OOW_authVisualGrid",
  "backButton": "Z80OOW_backButton",
  "brand": "Z80OOW_brand",
  "brandLogo": "Z80OOW_brandLogo",
  "cardSectionTitle": "Z80OOW_cardSectionTitle",
  "cncPassHint": "Z80OOW_cncPassHint",
  "compactField": "Z80OOW_compactField",
  "compactFieldActive": "Z80OOW_compactFieldActive",
  "configControls": "Z80OOW_configControls",
  "configurationStep": "Z80OOW_configurationStep",
  "consent": "Z80OOW_consent",
  "contactCard": "Z80OOW_contactCard",
  "continueButton": "Z80OOW_continueButton",
  "continueHint": "Z80OOW_continueHint",
  "continueWrap": "Z80OOW_continueWrap",
  "controlIntro": "Z80OOW_controlIntro",
  "controlSection": "Z80OOW_controlSection",
  "cutButton": "Z80OOW_cutButton",
  "cutButtonActive": "Z80OOW_cutButtonActive",
  "cutGrid": "Z80OOW_cutGrid",
  "cutSettings": "Z80OOW_cutSettings",
  "dialogBackdrop": "Z80OOW_dialogBackdrop",
  "dialogClose": "Z80OOW_dialogClose",
  "dimensionRangeList": "Z80OOW_dimensionRangeList",
  "disclaimer": "Z80OOW_disclaimer",
  "documentsGrid": "Z80OOW_documentsGrid",
  "draftBadge": "Z80OOW_draftBadge",
  "draftBanner": "Z80OOW_draftBanner",
  "draftIcon": "Z80OOW_draftIcon",
  "draftResume": "Z80OOW_draftResume",
  "drawingCard": "Z80OOW_drawingCard",
  "eyebrow": "Z80OOW_eyebrow",
  "eyebrowLight": "Z80OOW_eyebrowLight",
  "fadeIn": "Z80OOW_fadeIn",
  "field": "Z80OOW_field",
  "fieldFull": "Z80OOW_fieldFull",
  "fieldMeasurementHint": "Z80OOW_fieldMeasurementHint",
  "finalPartGeneratedPreview": "Z80OOW_finalPartGeneratedPreview",
  "finalPartVisual": "Z80OOW_finalPartVisual",
  "finalPrice": "Z80OOW_finalPrice",
  "finalSummary": "Z80OOW_finalSummary",
  "finish": "Z80OOW_finish",
  "finishActive": "Z80OOW_finishActive",
  "finishList": "Z80OOW_finishList",
  "flowActionSummary": "Z80OOW_flowActionSummary",
  "flowActions": "Z80OOW_flowActions",
  "flowLoader": "Z80OOW_flowLoader",
  "flowMain": "Z80OOW_flowMain",
  "flowPage": "Z80OOW_flowPage",
  "flowSidebar": "Z80OOW_flowSidebar",
  "flowSidebarOpen": "Z80OOW_flowSidebarOpen",
  "formError": "Z80OOW_formError",
  "formGrid": "Z80OOW_formGrid",
  "generatedDoorPreview": "Z80OOW_generatedDoorPreview",
  "generatedDoorPreviewCanvas": "Z80OOW_generatedDoorPreviewCanvas",
  "generatedDoorPreviewStatus": "Z80OOW_generatedDoorPreviewStatus",
  "ghostButton": "Z80OOW_ghostButton",
  "hero": "Z80OOW_hero",
  "heroActions": "Z80OOW_heroActions",
  "heroCopy": "Z80OOW_heroCopy",
  "heroDoor": "Z80OOW_heroDoor",
  "heroEyebrow": "Z80OOW_heroEyebrow",
  "heroGeneratedPreview": "Z80OOW_heroGeneratedPreview",
  "heroGeometryPill": "Z80OOW_heroGeometryPill",
  "heroGrid": "Z80OOW_heroGrid",
  "heroMaterialPill": "Z80OOW_heroMaterialPill",
  "heroObjectArea": "Z80OOW_heroObjectArea",
  "heroOrbitOne": "Z80OOW_heroOrbitOne",
  "heroOrbitTwo": "Z80OOW_heroOrbitTwo",
  "heroPrimary": "Z80OOW_heroPrimary",
  "heroSecondary": "Z80OOW_heroSecondary",
  "heroTrust": "Z80OOW_heroTrust",
  "inputWithIcon": "Z80OOW_inputWithIcon",
  "landing": "Z80OOW_landing",
  "landingBody": "Z80OOW_landingBody",
  "leadTime": "Z80OOW_leadTime",
  "loginButton": "Z80OOW_loginButton",
  "machineCard": "Z80OOW_machineCard",
  "machineCardBody": "Z80OOW_machineCardBody",
  "machineCardSelected": "Z80OOW_machineCardSelected",
  "machineGrid": "Z80OOW_machineGrid",
  "machinePhoto": "Z80OOW_machinePhoto",
  "machinePhotoImage": "Z80OOW_machinePhotoImage",
  "machinePhotoPlaceholder": "Z80OOW_machinePhotoPlaceholder",
  "materialButton": "Z80OOW_materialButton",
  "materialGrid": "Z80OOW_materialGrid",
  "materialMeta": "Z80OOW_materialMeta",
  "materialSelected": "Z80OOW_materialSelected",
  "materialShowcase": "Z80OOW_materialShowcase",
  "materialSwatches": "Z80OOW_materialSwatches",
  "mobileFlowTopbar": "Z80OOW_mobileFlowTopbar",
  "mobileProgress": "Z80OOW_mobileProgress",
  "mobileSidebarClose": "Z80OOW_mobileSidebarClose",
  "outputActions": "Z80OOW_outputActions",
  "outputCardHeader": "Z80OOW_outputCardHeader",
  "outputIcon": "Z80OOW_outputIcon",
  "outputIconWarm": "Z80OOW_outputIconWarm",
  "previewActions": "Z80OOW_previewActions",
  "previewButton": "Z80OOW_previewButton",
  "previewButtonActive": "Z80OOW_previewButtonActive",
  "previewCanvas": "Z80OOW_previewCanvas",
  "previewCanvasMuted": "Z80OOW_previewCanvasMuted",
  "previewCanvasWrap": "Z80OOW_previewCanvasWrap",
  "previewColumn": "Z80OOW_previewColumn",
  "previewDimensionsOverlay": "Z80OOW_previewDimensionsOverlay",
  "previewError": "Z80OOW_previewError",
  "previewIconButton": "Z80OOW_previewIconButton",
  "previewModeSwitch": "Z80OOW_previewModeSwitch",
  "previewShell": "Z80OOW_previewShell",
  "previewStats": "Z80OOW_previewStats",
  "previewTopbar": "Z80OOW_previewTopbar",
  "priceBreakdown": "Z80OOW_priceBreakdown",
  "priceTotal": "Z80OOW_priceTotal",
  "primaryButton": "Z80OOW_primaryButton",
  "primaryButtonWide": "Z80OOW_primaryButtonWide",
  "processCard": "Z80OOW_processCard",
  "processGrid": "Z80OOW_processGrid",
  "processIntro": "Z80OOW_processIntro",
  "productCard": "Z80OOW_productCard",
  "productCardBody": "Z80OOW_productCardBody",
  "productCardSelected": "Z80OOW_productCardSelected",
  "productGeneratedPreview": "Z80OOW_productGeneratedPreview",
  "productGrid": "Z80OOW_productGrid",
  "productVisual": "Z80OOW_productVisual",
  "quoteCard": "Z80OOW_quoteCard",
  "quoteProduct": "Z80OOW_quoteProduct",
  "quoteProductGeneratedPreview": "Z80OOW_quoteProductGeneratedPreview",
  "quoteProductPreview": "Z80OOW_quoteProductPreview",
  "rangeField": "Z80OOW_rangeField",
  "rangeFieldActive": "Z80OOW_rangeFieldActive",
  "rangeSlider": "Z80OOW_rangeSlider",
  "rangeValueEditor": "Z80OOW_rangeValueEditor",
  "readyBadge": "Z80OOW_readyBadge",
  "referenceBox": "Z80OOW_referenceBox",
  "saveExit": "Z80OOW_saveExit",
  "secondaryButton": "Z80OOW_secondaryButton",
  "secondaryButtonWide": "Z80OOW_secondaryButtonWide",
  "sectionHeading": "Z80OOW_sectionHeading",
  "sectionNumber": "Z80OOW_sectionNumber",
  "secureSend": "Z80OOW_secureSend",
  "segment": "Z80OOW_segment",
  "segmentActive": "Z80OOW_segmentActive",
  "segmented": "Z80OOW_segmented",
  "segmentedSmall": "Z80OOW_segmentedSmall",
  "selectedTick": "Z80OOW_selectedTick",
  "sendGrid": "Z80OOW_sendGrid",
  "sidebarIntro": "Z80OOW_sidebarIntro",
  "sidebarStatus": "Z80OOW_sidebarStatus",
  "spin": "Z80OOW_spin",
  "statusWarning": "Z80OOW_statusWarning",
  "step": "Z80OOW_step",
  "stepActive": "Z80OOW_stepActive",
  "stepContent": "Z80OOW_stepContent",
  "stepDone": "Z80OOW_stepDone",
  "stepFrame": "Z80OOW_stepFrame",
  "stepFrameWide": "Z80OOW_stepFrameWide",
  "stepHeader": "Z80OOW_stepHeader",
  "stepper": "Z80OOW_stepper",
  "stockAllowanceBox": "Z80OOW_stockAllowanceBox",
  "stockAllowanceInputs": "Z80OOW_stockAllowanceInputs",
  "submitError": "Z80OOW_submitError",
  "successActions": "Z80OOW_successActions",
  "successAmbient": "Z80OOW_successAmbient",
  "successCard": "Z80OOW_successCard",
  "successIcon": "Z80OOW_successIcon",
  "successPage": "Z80OOW_successPage",
  "successStats": "Z80OOW_successStats",
  "technicalDrawing": "Z80OOW_technicalDrawing",
  "topbar": "Z80OOW_topbar",
  "topbarActions": "Z80OOW_topbarActions",
  "topbarCenter": "Z80OOW_topbarCenter",
  "userButton": "Z80OOW_userButton",
  "userContext": "Z80OOW_userContext",
  "validationError": "Z80OOW_validationError",
  "validationNotice": "Z80OOW_validationNotice",
});
